"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/PenTool` instead */
export const PenTool = createSVGIcon(
  <path
    d="M3.226 8.15 1.042 21.978a.857.857 0 0 0 .98.98l13.83-2.184a1.714 1.714 0 0 0 1.436-1.503l.713-6.415L11.144 6l-6.414.713a1.714 1.714 0 0 0-1.504 1.436ZM11.143 6 14.572.857M18 12.857l5.143-3.428M1.714 22.286l6.858-6.857M6.857 13.714l3.429 3.429"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "PenTool",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
